"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNavigationCapability = void 0;
var UserNavigationCapability;
(function (UserNavigationCapability) {
    UserNavigationCapability["NAVIGATION_GO_TO_TSC"] = "navigation:go_to_tsc";
})(UserNavigationCapability || (exports.UserNavigationCapability = UserNavigationCapability = {}));
